import React, { useEffect } from "react";
import InformationsDemandeur from "../formSections/InformationsDemandeur";
import InformationsLocal from "../formSections/InformationsLocal";
import InformationsProjet from "../formSections/InformationsProjet";
import Validation from "../formSections/Validation";

const FormulairePdf = ({
  formData,
  setFormData,
  handleChange,
  professional,
  professionals,
  handleSignatureEnd,
  clearSignature,
  sigRef,
  confirmMandantEmail,
  confirmMandataireEmail,
  inputFocus,
  setProfessional,
  setProfessionals,
  ville,
  signature,
  setSignature,
  tooltip,
  page,
  listeUrls3DOuest,
}) => {
  const labels = {};

  useEffect(() => {
    formData.Signature = signature;
    setFormData({ ...formData });
  }, [signature]);

  //** permet de masquer tous les inputs uploads sur la page de vérification */
  document.querySelectorAll(".form-upload").forEach((input) => {
    if (page === 5) {
      input.classList.add("d-none");
      input.removeAttribute("required");
    }
  });

  //** Permet de passer tous les champs en disabled sur la page de vérification */
  document.querySelectorAll("input").forEach((input) => {
    if (page === 5 && input.type !== "button" && input.type !== "submit") {
      input.setAttribute("disabled", true);
    }
  });

  document.querySelectorAll(".form-select").forEach((select) => {
    if (page === 5) {
      select.setAttribute("disabled", true);
    }
  });

  //** Permet de convertir la date au format text(DD MM YYYY) lors de l'envoi du formulaire et de l'impression pdf */
  // document.querySelectorAll("input[type='date']").forEach((input) => {
  //   let date = moment(formData[input.name]).format("DD/MM/YYYY");
  //   input.type = "text";
  //   input.value = date;
  //   formData[input.name] = date;
  // });

  //ne pas afficher le bouton pour vérifier le renouvellement
  document?.querySelector("div.btn-renouvellement")?.classList.add("d-none");

  //ne pas afficher les boutons liés à l'ajout de référence
  document?.querySelector(".addReference")?.classList.add("d-none");
  document
    ?.querySelectorAll(".deleteReference")
    ?.forEach((corbeille) => corbeille.classList.add("d-none"));

  // afficher le statut "propriétaire
  document.querySelector(".LocMandantStatut")?.classList.remove("d-none");

  // afficher l'activité "location meublé"
  document.querySelector(".ProActivite")?.classList.remove("d-none");

  // affiche la photo du bien seulement si la photo a été uploadé
  if (formData.files?.ProPhoto?.length < 1) {
    document.querySelector(".ProPhoto")?.classList.replace("d-block", "d-none");
  }

  useEffect(() => {
    const elements = document.querySelectorAll(".getLabel");
    elements.forEach((element) => {
      const label = document.querySelector(`label[for="${element.id}"]`);
      if (label) {
        labels[element.name + "_label"] = label.textContent;
        setFormData({ ...formData, labels });
      }
    });
  }, []);

  useEffect(() => {
    const formElements = document.querySelectorAll("form [name]");
    const fieldOrder = Array.from(formElements).map((el) => el.name);
    const sortedFormData = {};

    fieldOrder.forEach((fieldName) => {
      if (formData.hasOwnProperty(fieldName)) {
        sortedFormData[fieldName] = formData[fieldName];
      }
    });
    setFormData((prevFormData) => ({
      ...sortedFormData,
      ...prevFormData,
    }));
  }, []);

  return (
    <div id="pdf">
      <div className="page">
        <InformationsDemandeur
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          confirmMandataireEmail={confirmMandataireEmail}
          confirmMandantEmail={confirmMandantEmail}
          professional={professional}
          setProfessional={setProfessional}
          professionals={professionals}
          setProfessionals={setProfessionals}
          ville={ville}
          listeUrls3DOuest={listeUrls3DOuest}
        />
      </div>
      <div className="page">
        <InformationsProjet
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          confirmMandataireEmail={confirmMandataireEmail}
          confirmMandantEmail={confirmMandantEmail}
          professional={professional}
          setProfessional={setProfessional}
          professionals={professionals}
          setProfessionals={setProfessionals}
          ville={ville}
          page={page}
        />
      </div>
      <div className="page">
        <InformationsLocal
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          confirmMandataireEmail={confirmMandataireEmail}
          confirmMandantEmail={confirmMandantEmail}
          inputFocus={inputFocus}
          professional={professional}
          setProfessional={setProfessional}
          professionals={professionals}
          setProfessionals={setProfessionals}
          ville={ville}
          page={page}
        />
      </div>
      <div className="page">
        <Validation
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          confirmMandataireEmail={confirmMandataireEmail}
          confirmMandantEmail={confirmMandantEmail}
          handleSignatureEnd={handleSignatureEnd}
          clearSignature={clearSignature}
          sigRef={sigRef}
          inputFocus={inputFocus}
          professional={professional}
          setProfessional={setProfessional}
          professionals={professionals}
          setProfessionals={setProfessionals}
          signature={signature}
          setSignature={setSignature}
          ville={ville}
          tooltip={tooltip}
          page={page}
        />
      </div>
    </div>
  );
};

export default FormulairePdf;
